<template>
<div style="width: 100%;" class="table">
  <el-table :data="tableData" style="width: 100%;" size="mini" border  :header-cell-style="{background:'#f6faff','text-align':'center' }" :key="recordId">
    <template slot="empty">
      <el-button v-if="tableDataLoading" type="text" :loading="true">加载中</el-button>
      <div class="no-data">
        <!-- <img v-if="!tableDataLoading" style="width: 250px" src="./../../static/img/none.png" alt=""> -->
        <span v-if="!tableDataLoading">暂无{{baseData.recordName}}信息</span>
      </div>
    </template>
    <el-table-column prop="indexNum" label="序号" type="index"></el-table-column>
    <template v-if="formList.length">
    <el-table-column v-for="(item,index) in formList" :key="index" :min-width="140" :prop="item.valueKey"
      :label="item.rfName" show-overflow-tooltip align="center">
      <template #header>
        <p v-if="isEdit&&item.rfRemake!=''&&item.rfRemake">
          {{item.rfName}}
          <span v-if="item.rfIsMust==1" style="color: red">*</span>
          <el-tooltip class="item" effect="dark" :content="item.rfRemake" placement="right">
            <i class="el-icon-question" style="margin-left:5px;color:grey"></i>
          </el-tooltip>
        </p>
        <p v-else>{{item.rfName}}<span v-if="item.rfIsMust==1&&isEdit" style="color: red">*</span></p>
      </template>
      <template slot-scope="scope">
        <div v-if="item.rfType==1" ref="formText" style="padding:0 8px;" :class="{'width-100':isEdit}">
          <div v-if="!isEdit" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{tableData[scope.$index][item.valueKey]|empty}}</div>
          <el-input v-else v-model="tableData[scope.$index][item.valueKey]" width=100></el-input>
        </div>
        <!-- 长文本 -->
        <div v-if="item.rfType==2" ref="formText" style="padding:5px 8px;" :class="{'width-100':isEdit}">
          <div v-if="!isEdit" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{tableData[scope.$index][item.valueKey]|empty}}</div>
          <el-input type="textarea" rows="1" v-else v-model="tableData[scope.$index][item.valueKey]" width=100></el-input>
        </div>
        <!-- 单选项/多选项 -->
        <div v-if="item.rfType==3||item.rfType==4" ref="formText" style="padding:0 8px;" :class="{'width-100':isEdit}">
          <el-select v-if="isEdit" v-model="tableData[scope.$index][item.valueKey]" clearable placeholder="请选择" :multiple="item.rfType==4" :disabled="!isEdit" width=100>
            <el-option
              v-for="item in getOptions(item.rfTypeNames)"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <div v-else style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectOption(tableData[scope.$index][item.valueKey])|empty}}</div>
        </div>
        <!-- 附件 -->
        <div v-if="item.rfType==5" style="padding:0 8px;" class="file-box">
          <a v-if="tableData[scope.$index][item.valueKey]" target="_blank" :href="getFilePath(tableData[scope.$index][item.valueKey])" class="file-style ellipsis-text" :class="{'file-edit':isEdit}">
            <i class="el-icon-document"></i>
            {{getFileName(tableData[scope.$index][item.valueKey])}}
          </a>
          <p v-else>-</p>&nbsp;&nbsp;
          <!-- <p v-if="!tableData[scope.$index][item.valueKey]&&isEdit"><i class="el-icon-upload2"></i>上传</p> -->
          <v-file-upload :number="1" v-if="!tableData[scope.$index][item.valueKey]&&isEdit" @onFileChange="onFileChange(arguments,scope.$index,item.valueKey)"></v-file-upload>
          <p v-if="tableData[scope.$index][item.valueKey]&&isEdit" @click="delFile(scope.$index,item.valueKey)">删除</p>
        </div>
        <!-- 日期选择器 -->
        <div v-if="item.rfType==6" style="padding:0 8px;">
          <el-date-picker
            v-if="isEdit"
            v-model="tableData[scope.$index][item.valueKey]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <p v-else class="ellipsis-text">{{tableData[scope.$index][item.valueKey]|empty}}</p>
        </div>
      </template>
    </el-table-column>
    </template>
    <el-table-column label="操作" align="right" v-if="isEdit">
      <template slot-scope="scope">
        <el-button size="mini" type="danger"
                   @click="del(scope.$index)">删除
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <p class="add-row" v-if="isEdit" @click="add()"> + 添加一行</p>
</div>
</template>

<script>
import * as getData from './../service/getData'
export default {
  name: '',
  props: ['isEdit', 'baseData','recordId'],
  components: {},
  data () {
    return {
      tableDataLoading: false,
      tableData: [],
      formList: [],
      specialEquipmentList: [],
      delArr: [],
      isE: false
    }
  },

  mounted() {
    // let arr = []
    // this.specialEquipmentList.forEach((item)=>{
    //   arr.push(JSON.parse(item.cdValue))
    // })
    // for(let i=0;i<this.specialEquipmentList.length;)
    this.formList = this.baseData.companyDataListVos
    this.specialEquipmentList = this.baseData.companyDataTableListVos

    let arr = []
    for(let i=0;i<this.specialEquipmentList.length;i++){
      arr.push(JSON.parse(this.specialEquipmentList[i].cdValue))
    }
    this.tableData = arr
  },
  watch: {
    baseData: function () {
      this.formList = this.baseData.companyDataListVos
      this.specialEquipmentList = this.baseData.companyDataTableListVos

      let arr = []
      for(let i=0;i<this.specialEquipmentList.length;i++){
        arr.push(JSON.parse(this.specialEquipmentList[i].cdValue))
      }
      this.tableData = arr
    },
    isEdit: function() {
      this.isE = this.isEdit
    },
  },
  

  methods: {
    look(row,item){
      console.log(row,item);
    },
    add() {
      var obj = new Object();
      this.formList.forEach((ele,index) =>{
        let nature = ele.valueKey;
        obj[nature] = ''
      })
      this.tableData.push(obj);
      this.specialEquipmentList.push({
        id: null,
        cdId: null,
        cdValue: ""
      })
    },
    save() {
      let name = ''
      for(let i=0;i<this.formList.length;i++){
        name = ''
        if(this.formList[i].rfIsMust){
          for(let j=0;j<this.tableData.length;j++){
            if(this.tableData[j][this.formList[i].valueKey]==''){
              name = this.formList[i].rfName
              break;
            }
          }
        }
        if(name!=''){
          break;
        }
      }
      if(name!=''){
        this.$message.error(name+'不能为空')
      }else{
        // this.$emit('load')
        // console.log(this.tableData)
        for(let i=0;i<this.specialEquipmentList.length;i++){
          this.baseData.companyDataTableListVos[i].cdValue = JSON.stringify(this.tableData[i])
          this.baseData.companyDataTableListVos[i].id = i+1
        }
        this.baseData.delCompanyData = this.delArr
        getData.updateCompany(this.baseData).then(res=>{
          if(res.data.code === 1){
            this.$message.success('操作成功')
            this.$emit('load')
            this.delArr = []
          }else{
            this.$message.error(res.data.message)
          }
        })
        console.log(this.baseData)
      }
    },
    del(index) {
      this.$confirm('删除后将无法恢复，确认删除当前行？','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(this.specialEquipmentList[index].cdId) {
          this.delArr.push(this.specialEquipmentList[index].cdId)
        }
        this.specialEquipmentList.splice(index,1)
        this.tableData.splice(index,1)
        this.$message.success('操作成功')
      }).catch((e) => {
        this.$message.info('操作取消')
        console.log(e)
      })
    },
    selectOption(itemData) {
      if(Array.isArray(itemData)){
        return itemData.join('，')
      }else{
        return itemData
      }
    },
    getOptions(val){
      if(val){
        let arr = val.split('$-$')
        return arr
      }
    },
    onFileChange(obj,index,key) {
      let file = {
        fileName: obj[0].fileList[0].fileName,
        filePath: obj[0].fileList[0].exportFile
      }
      this.tableData[index][key] = JSON.stringify(file)
    },
    delFile(index,key){
      this.$confirm('确认要删除该附件吗','提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>{
        this.tableData[index][key] = ''
      }).catch(()=>{
        this.$message.info('操作取消')
      })
    },
    getFilePath(data) {
      return JSON.parse(data).filePath
    },
    getFileName(data) {
      return JSON.parse(data).fileName
    }
  },
}

</script>
<style lang='scss' scoped>
.form-title{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  background: #f6faff;
  margin: 0 -1px -1px 0;
}
.form-value{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  margin: 0 0 -1px 0;
}
.ellipsis-text{
  text-align:center;
  overflow: hidden; /*隐藏溢出的文本  */
  text-overflow: ellipsis;
  word-break: break-all;/*自动换行*/
  -webkit-line-clamp:1; /*显示的行数*/
  -moz-box-orient: vertical; /*从上到下自动排列子元素*/
  -webkit-box-orient: vertical; 
  display: -webkit-box ;
  width: 100%;
}
.width-100{
  width: 100%;
}
.file-style{
  color: rgb(0, 110, 255);
  
}
.file-style:hover{
  text-decoration: underline;
  font-weight: bold;
}
.file-box{
  cursor: pointer;
  display: flex;
  justify-content: center;
  p{
    margin-left: 8px;
  }
  p:hover{
    text-decoration: underline;
    font-weight: bold;
  }
  p:hover i{
    font-weight: bold;
  }
}
.file-edit{
  width: calc(100% - 50px);
}
.add-row{
  height: 36px;
  margin: 10px 0;
  border: 1px dashed#e0e9fb;
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  color: #333;
}
.no-data{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
}
</style>
<style lang="scss">
  .table{
    .el-table--border{
      border: 1px solid #EBEEF5;
    }
  }
  .el-tooltip__popper{
    max-width: 250px;
  }
  .el-input {
    height: auto;
  }
  .el-select-dropdown.is-multiple span{
    margin-right: 20px;
  }
  /* .el-select__tags-text {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

} */
.el-select__tags-text {
  display: inline-block;
  width: 38px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
  </style>





// WEBPACK FOOTER //
// src/components/table-input.vue